const CHECK_INTERVAL_IN_MS = 100;

export const loadDG = (): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    if ('DG' in window) {
      return resolve();
    }

    const script = document.createElement('script');

    script.src = 'https://maps.api.2gis.ru/2.0/loader.js?pkg=full';
    script.async = true;
    script.onload = () => {
      const checkDGReadyInterval = setInterval(() => {
        if ('DG' in window && window.DG.ready) {
          clearInterval(checkDGReadyInterval);
          window.DG.plugin('https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js').then(resolve).catch(reject);
        }
      }, CHECK_INTERVAL_IN_MS);
    };
    script.onerror = (_1, _2, _3, _4, err) => reject(err);

    document.body.appendChild(script);
  });
};
